import React from 'react';
import { observer } from 'mobx-react';
import { FormField } from '../../../../../../../../global/form/form-field/form-field';
import { OEToggle } from '../../../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../../../global/text/text';
import { CustomFieldsOptionsListDTO, ReplaysPageLayoutOptions, UpcomingSessionsTypeOptions } from '../../../../../../../../../api/custom-pages.dao';
import { EnablementStatus } from '../../../../../../../../../constants/common.constants';
import { HOST_ATTENDEES_ENABLED } from '../../../../../../../../../modules/passport-pages/config';
import { DefaultPageViewModel } from '../../default-page.viewmodel';
import { ReplaysNotesField } from './_replays-notes/replays-notes-field';
import { ReplaysLayoutSection } from './_replays-layout/replays-layout-section';
import { UpcomingSessionsSection } from './_upcoming-sessions/upcoming-sessions-section';
import { RestrictAccessSection } from './_restrict-access/restrict-access-section';

type IProps = {
    pageVm: DefaultPageViewModel;
    upcomingSessionsTypeOptions: UpcomingSessionsTypeOptions[];
    replaysLayoutOptions: ReplaysPageLayoutOptions[];
    organizationTypes: string[];
    customFieldsOptionsList: CustomFieldsOptionsListDTO[];
};

export const ReplaysPageFields = observer(({
    pageVm,
    upcomingSessionsTypeOptions = [],
    replaysLayoutOptions = [],
    organizationTypes,
    customFieldsOptionsList,
}: IProps): JSX.Element => {
    const { value: hostAttendeesEnabled } = pageVm.getFieldByKey(HOST_ATTENDEES_ENABLED);
    const handleToggleHostAttendees = () =>
        pageVm.setFieldValueByKey(HOST_ATTENDEES_ENABLED, !hostAttendeesEnabled);

    return (
        <>
            <ReplaysNotesField pageVm={pageVm} />
            <FormField>
                <div className='website-custom__checkbox-label m-bottom-0px'>
                    <OEToggle
                        isSelected={hostAttendeesEnabled as boolean}
                        onClick={handleToggleHostAttendees}
                        dataTestId='host-attendees-toggle'
                    />
                    <Text
                        message='Display Host attendees is {suffix}'
                        id='oe.defaultPage.replaysHostAttendeesEnabled'
                        description='Label text'
                        values={{
                            suffix: hostAttendeesEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED
                        }}
                    />
                </div>
            </FormField>
            <ReplaysLayoutSection pageVm={pageVm} layoutOptions={replaysLayoutOptions} />
            <UpcomingSessionsSection pageVm={pageVm} sessionTypeOptions={upcomingSessionsTypeOptions} />
            <RestrictAccessSection
                pageVm={pageVm}
                organizationTypes={organizationTypes}
                customFieldsOptionsList={customFieldsOptionsList}
            />
        </>
    );
});